import React from 'react';

import './MainPage.sass';

import {injectIntl, FormattedMessage} from 'react-intl';
import {connect} from 'react-redux';
import animateScrollTo from 'animated-scroll-to';
import * as Cookie from 'js-cookie';

import {fetchRootTaxon} from '../../ducks/taxons';
import {BG_HOMEPAGE, setBackground} from '../../ducks/ui';
import {isMainTaxon} from '../../utils/taxons';

import Hero from '../../components/hero/Hero';
import Games from '../../components/games/Games';
import ProductList from '../productList/ProductList';
import Button from '../../components/button/Button';
import Loader from '../../components/loader/Loader';
import Meta from '../../components/meta/Meta';
import JSONLDBoosthive from '../../components/JSON-LD/JSONLDBoosthive';
import WhyUsSection from '../../components/whyUsSection/WhyUsSection';
import Tabs from '../../components/tabs/Tabs';
import CategoryMenuGames from '../../components/categoryMenu/CategoryMenuGames';

@injectIntl
@connect(({taxons}) => ({
  rootTaxon: taxons.root.taxon,
  categories: taxons.root.children
}))
export default class MainPage extends React.PureComponent {
  static fetchData = ({dispatch, rootTaxon}) => rootTaxon === undefined && dispatch(fetchRootTaxon());

  constructor(props) {
    super(props);
    if (Cookie.get('blacklist')) {
      const excludedTaxons = JSON.parse(Cookie.get('blacklist'));

      if (excludedTaxons.includes(process.env.PRIMARY_TAXON)) {
        this.state = {featuredTaxon: process.env.ALTERNATIVE_TAXON};
      } else {
        this.state = {featuredTaxon: process.env.PRIMARY_TAXON};
      }
    } else {
      this.state = {featuredTaxon: process.env.PRIMARY_TAXON};
    }
  }

  componentDidMount() {
    const {dispatch} = this.props;

    dispatch(setBackground(BG_HOMEPAGE));
    MainPage.fetchData(this.props);
  }

  componentDidUpdate() {
    MainPage.fetchData(this.props);
  }

  render() {
    const {intl, rootTaxon, categories} = this.props;
    const {featuredTaxon} = this.state;

    const rootTaxonMeta = (rootTaxon && rootTaxon.metatag) || {};

    let mainCategories;
    if (Array.isArray(categories) && categories.length) {
      mainCategories = categories.filter(isMainTaxon).map(it => ({
        name: it.name,
        value: it.slug,
        code: it.code
      }));
    }

    if (Cookie.get('blacklist')) {
      const excludedTaxons = JSON.parse(Cookie.get('blacklist'));

      mainCategories =
        mainCategories && mainCategories.filter(({ value }) => !excludedTaxons.includes(value));
    }

    return (
      <div>
        <Meta
          title={rootTaxonMeta.pageTitle}
          description={rootTaxonMeta.description}
          keywords={rootTaxonMeta.keywords}
          alternateSlug='/'
        />

          <JSONLDBoosthive />

          <Hero
            title={intl.formatMessage({id: 'page.main.title'})}
            subtitle={intl.formatMessage({id: 'page.main.subtitle'})}
          >
            <Button onClick={() => animateScrollTo(this._gamesWeSupport)} big filled>
              <FormattedMessage id="page.main.choose"/>
            </Button>

            <Button big onClick={() => animateScrollTo(this._navReviews)}>
              <FormattedMessage id="page.main.see-reviews"/>
            </Button>
          </Hero>

          <div ref={gamesWeSupport => this._gamesWeSupport = gamesWeSupport}/>

          <section className="container">
            <h2 className="text-center">
              <FormattedMessage id="page.main.games-support"/>
            </h2>
          </section>

          <Games categories={categories} intl={intl} />

          {mainCategories ? (
            <section className="container">
              <h2 className="text-center">
                <FormattedMessage id="page.main.top-selling"/>
              </h2>

                <div className="main-page__products-tabs">
                  <Tabs
                    items={mainCategories}
                    active={featuredTaxon}
                    onChange={taxon => this.setState({featuredTaxon: taxon})}
                  />
                </div>
                <CategoryMenuGames
                  items={mainCategories}
                  active={featuredTaxon}
                  onItemClick={taxon => this.setState({featuredTaxon: taxon})}
                />

                <div className="main-page__products">
                  <ProductList
                    type="popular"
                    taxon={featuredTaxon}
                    mainTaxon={mainCategories.find(category => category.value === featuredTaxon)}
                  />
                  </div>
              </section>
          ) : (
          <Loader section/>
          )}

          <div ref={navReviews => this._navReviews = navReviews}/>

          <WhyUsSection/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./containers/mainPage/MainPage.js